module.exports = __webpack_public_path__ + "img/SOKAL-SRS-120921-Clarity-Playful.84da0924.jpeg";